export default __webpack_public_path__ + "static/media/PowerPrivilegeposture.949ce1bc.png";